export const colors = {
  magenta: {
    50: '#FFF1F8',
    100: '#FCE7F1',
    200: '#F8C9DF',
    300: '#EFA1C2',
    400: '#D9669C',
    500: '#A02862',
    600: '#8B1B5E',
    700: '#7B1F47',
    800: '#5C0F35',
    900: '#3B0820',
    950: '#240414',
  },
  crema: {
    50: '#FAF7F4',
    100: '#F4EFE9',
    200: '#E9DFD2',
    300: '#D4C2AB',
  },
  success: { 50: '#E8F8EE', 500: '#0F9D58', 600: '#0B7E47' },
  warning: { 50: '#FEF6E7', 500: '#F59E0B', 600: '#B7770A' },
  danger: { 50: '#FDECEC', 500: '#DC2626', 600: '#B61F1F' },
  ink: {
    50: '#F8FAFC',
    100: '#F1F5F9',
    200: '#E2E8F0',
    300: '#CBD5E1',
    400: '#94A3B8',
    500: '#64748B',
    600: '#475569',
    700: '#334155',
    800: '#1E293B',
    900: '#0F172A',
  },
  white: '#FFFFFF',
  black: '#000000',
  transparent: 'transparent',
} as const;

export const spacing = {
  0: 0,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  8: 32,
  10: 40,
  12: 48,
  16: 64,
  20: 80,
  24: 96,
} as const;

export const radius = {
  sm: 6,
  md: 10,
  lg: 16,
  xl: 20,
  '2xl': 24,
  '3xl': 28,
  '4xl': 32,
  full: 9999,
} as const;

export const typography = {
  display: { fontFamily: 'Fredoka', letterSpacing: -0.2 },
  body: { fontFamily: 'Nunito', letterSpacing: 0 },
  weights: {
    regular: '400' as const,
    medium: '500' as const,
    semibold: '600' as const,
    bold: '700' as const,
    extrabold: '800' as const,
  },
  sizes: {
    xs: 12,
    sm: 13,
    base: 15,
    md: 16,
    lg: 18,
    xl: 20,
    '2xl': 24,
    '3xl': 30,
    '4xl': 36,
    '5xl': 48,
  },
} as const;

export const shadows = {
  card: {
    shadowColor: '#5C0F35',
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.1,
    shadowRadius: 18,
    elevation: 4,
  },
  soft: {
    shadowColor: '#5C0F35',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 12,
    elevation: 2,
  },
  glow: {
    shadowColor: '#A02862',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.35,
    shadowRadius: 24,
    elevation: 8,
  },
} as const;

export type ColorScale = keyof typeof colors.magenta;

export const theme = { colors, spacing, radius, typography, shadows } as const;
